export default __webpack_public_path__ + "static/media/boy7.b0811029.svg";